import React from "react"
import { Component } from "react";
import { Link } from "react-router-dom";

//Imagenes
import Receta from "../../../img/Frontend/01-Maquetado/limon.png"
import Batman from "../../../img/Frontend/01-Maquetado/logobatman.png"
import Cards from "../../../img/Frontend/01-Maquetado/CardsSuperheroes.png"

//Componentes externos
import Tarjeta from "../TarjetasHtml"
import Header from "../../Header"

//Estilos
import "../../../styles/frontend/Maquetado.css"

//Bibliotecas externas
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Cookies from "universal-cookie"
import PropTypes from "prop-types"
import {setLanguage, translate} from 'react-switch-lang';


const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1365 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1365, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const PetShop = "https://cdn-icons-png.flaticon.com/512/1312/1312500.png";

class Maquetado extends Component{

  constructor(props){
    super(props);
    const cookieLanguage = new Cookies('language');
    const lang = cookieLanguage.get('language');
    setLanguage(lang);
    
}

    render(){

      const {t} = this.props;
      
        return(
          <div className="divCarrouselContainer">
            <Header urlBack="/My-Portfolio/frontend" showIcons={true}/>

              <Carousel responsive={responsive} containerClass="carouselMaquetado">
                  <Tarjeta link="https://4nr3.github.io/Receta/" imagen={Receta} alter="Receta" titulo={t('maquetado.lemonPie')}/>
                  <Tarjeta link="https://4nr3.github.io/CVBatman/" imagen={Batman} alter="CVBatman" titulo={t('maquetado.batman')}/>
                  <Tarjeta link="https://4nr3.github.io/Pizzeria/" imagen="https://cdn-icons-png.flaticon.com/512/1404/1404945.png" alter="Pizzeria" titulo={t('maquetado.pizzeria')}/>
                  <Tarjeta link="https://4nr3.github.io/CardsSuperheroes/" imagen={Cards} alter="Cards" titulo={t('maquetado.cards')}/>
                  <Tarjeta link="https://4nr3.github.io/PetShop/" imagen={PetShop} alter="PetShop" titulo={t('maquetado.petShop')}/>
              </Carousel>
            </div>
        )
    }


}

Maquetado.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(Maquetado);